module.exports = __webpack_public_path__ + "media/images/default/pages/public_science_1/an-insomnia-woman-on-bed-b1455e42f5741ffc2beee1c3f033c324.jpeg";